import React, { Component } from 'react';
import { connect } from 'react-redux'
import {
    loadProjects
} from './../redux/actions/actions'
import { Grid, Row, Col } from 'react-bootstrap/lib';
import Slider from 'react-slick/lib';
import { history } from '../redux/store';

const mapStateToProps = state => {
    return {
        projects: state.projects.projects
    }
}

class Home extends Component {
    componentWillReceiveProps(nextProps) {

    }

    componentWillMount() {
        this.props.loadProjects()
    }

    render() {
        const projects = this.props.projects.map((project) =>
            <div key={project.id} className="project-box">
                <img src={project.thumbnail_img} className="project-logo" alt={project.title} />
                <h3 className="text-left title">{project.description}</h3>
                <p className="text-left tag">{project.tags}</p>
                <p className="text-left"><a onClick={() => { history.push(`/project/${project.id}`) }}>Know More →</a></p>
            </div>
        );
        const projectsSliderSettings = {
            className: "center",
            centerMode: true,
            infinite: true,
            centerPadding: "0px",
            slidesToShow: 3,
            initialSlide: 1,
            speed: 300,
            focusOnSelect: true,
        };
        const articlesSliderSettings = {
            arrows: false,
            infinite: true,
            centerPadding: "0px",
            slidesToShow: 3,
            speed: 600,
            autoplay: true,
            autoplaySpeed: 3000        
        };
        return (
            <main>
                <section className="main-section">
                    <Grid>
                        <Row>
                            <Col md={12}>
                                <h4 className="sub-heading">Subheading</h4>
                                <h1 className="heading purple"><span className="purple">main</span> heading <br /> section of the app</h1>
                                <div style={{ margin: "0 -3em" }}>
                                    <Slider {...projectsSliderSettings}>
                                        {projects}
                                    </Slider>
                                </div>
                            </Col>
                        </Row>
                    </Grid>
                </section>
                <section>
                    <Grid>
                        <Row>
                            <Col md={12}>
                                <h4 className="sub-heading">Subheading</h4>
                                <h1 className="heading blue"><span className="blue">second</span> heading <br /> section of the app</h1>
                                <div style={{ margin: "0 -3em" }}>
                                    <Slider {...articlesSliderSettings}>
                                        {projects}
                                    </Slider>
                                </div>
                            </Col>
                        </Row>
                    </Grid>
                </section>
            </main >
        );
    }
}

export default connect(mapStateToProps, { loadProjects })(Home);


// WEBPACK FOOTER //
// ./src/components/Home.js